<div class="dtffleet">
  <mat-toolbar style="min-height: 40px !important;height: 30px !important;">
    <span style="color: black; margin-right: 10px;">Hello {{ user }}</span>
    <button (click)="menuToggled.emit(true)" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>

    <mat-form-field style="width: 70rem; margin-right: 10px" floatLabel="never">
    <input matInput 
           #searchInput="matInput" 
           type="text" 
           placeholder="Search"  
           autocomplete="off"/>
    <mat-icon matSuffix>search</mat-icon>  
  </mat-form-field>

    <div style="text-align: right;">
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>home</mat-icon>
    </button>
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>mail</mat-icon>
    </button>
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>person_pin</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="logout()">
        <span>Logout</span>
      </button>
    </mat-menu>
    </div>
  </mat-toolbar>
  </div>